export default __webpack_public_path__ + "static/media/rabbit.b4d9ad38.png";